$(() => {
  $('.toggle-class').on('click', (e) => {
    e.preventDefault();
    const $this = $(e.currentTarget);
    $($this.data('target')).toggleClass($this.data('class'));
  });
});
